module.exports = __webpack_public_path__ + "img/bb5.8f3a9302.png";